import { render, staticRenderFns } from "./MainHome.vue?vue&type=template&id=db0fb214"
import script from "./MainHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainHome.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports